import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Workstation from './workstation';

@Model()
export default class WorkstationReboot extends ApplicationRecord {
  static jsonapiType = 'workstation_reboots';
  @Attr() state: string;
  @Attr() hard: boolean;
  @Attr() instanceProtectionOverride: boolean;

  @BelongsTo() workstation: Workstation;
}
